export const isPhoneE164 = value => !!value.match(/^\+[1-9]\d{1,14}$/);

/**
 * Builds the full international digit string from dial code + national part.
 * If the national field accidentally still starts with the country calling code
 * (common with imports), strips one duplicate prefix so length checks match E.164.
 */
export const getInternationalPhoneDigits = (dialCode, nationalValue) => {
  const dial = (dialCode || '').replace(/\D/g, '');
  let national = (nationalValue || '').replace(/\D/g, '');
  if (dial.length && national.startsWith(dial)) {
    national = national.slice(dial.length);
  }
  return `${dial}${national}`;
};

// E.164: max 15 digits total. Do not use String.replace(dialCode) — a 1-digit
// code like "1" would match the wrong digit inside the national number.
export const isPhoneNumberValid = (value, dialCode) => {
  if (/[a-zA-Z]/.test(value || '')) return false;

  const dialDigits = (dialCode || '').replace(/\D/g, '');
  if (!dialDigits.length) return false;

  const fullDigits = getInternationalPhoneDigits(dialCode, value);
  const nationalDigits = fullDigits.slice(dialDigits.length);

  if (!nationalDigits.length || !/^[0-9]+$/.test(fullDigits)) {
    return false;
  }

  const maxNationalLength = 15 - dialDigits.length;
  return nationalDigits.length <= maxNationalLength;
};

export const isPhoneE164OrEmpty = value => isPhoneE164(value) || value === '';

export const isPhoneNumberValidWithDialCode = value => {
  const number = value.replace(/^\+/, ''); // Remove the '+' sign
  return !!number.match(/^[1-9]\d{4,}$/); // Validate the phone number with minimum 5 digits
};

export const startsWithPlus = value => value.startsWith('+');

export const shouldBeUrl = (value = '') =>
  value ? value.startsWith('http') : true;

export const isValidPassword = value => {
  const containsUppercase = /[A-Z]/.test(value);
  const containsLowercase = /[a-z]/.test(value);
  const containsNumber = /[0-9]/.test(value);
  const containsSpecialCharacter = /[!@#$%^&*()_+\-=[\]{}|'"/\\.,`<>:;?~]/.test(
    value
  );
  return (
    containsUppercase &&
    containsLowercase &&
    containsNumber &&
    containsSpecialCharacter
  );
};

export const isNumber = value => /^\d+$/.test(value);

export const isDomain = value => {
  if (value !== '') {
    const domainRegex = /^([\p{L}0-9]+(-[\p{L}0-9]+)*\.)+[a-z]{2,}$/gmu;
    return domainRegex.test(value);
  }
  return true;
};
